import { styled } from 'libs/ui/styled';

export const UnidentifiableBeneficiaryMessageWrapperStyled = styled('div')(
  () => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 32,
    marginBottom: 32,
  })
);
